// Generated by CoffeeScript 2.7.0
var CascadedSelect, Selection;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

Selection = {
  props: ['selectionIndex', 'selected_ids', 'selection'],
  components: {
    'Popover': Popover
  },
  data: function() {
    return {
      displayValue: ''
    };
  },
  template: `<Popover position='bottom left'
         :caret='false'
         :customClass="['cascaded-select-popover']"
         type='select'
         size='default'
         ref='selection_popover'
         :blockContent='true'>
  <template slot='trigger'>
    <slot name='trigger'>
      <div class="input-control right-addon">
        <div class="controlled-input" v-show='displayValue'>{{ displayValue }}</div>
        <div class="controlled-input placeholder" v-show='!displayValue'>请选择</div>
        <div class="addon">
          <i class="slp-caret-down"></i>
        </div>
      </div>
    </slot>
  </template>
  <template slot='content'>
    <div class="list">
      <div class="list-item justify-between" v-for='(choice, index) in choices'
              :key='choice.id'
              @click='choiceClicked(choice)'>
          <span class="content text-ellipsis">{{ choice.name }}</span>
          <i :class="[choice.id == select_id ? 'slp-check' : 'slp-empty']"></i>
      </div>
    </div>
  </template>
</Popover>`,
  mounted: function() {
    var ref;
    return this.displayValue = (ref = this.selection.selectedOption) != null ? ref.name : void 0;
  },
  computed: {
    select_id: function() {
      return this.selected_ids[this.selectionIndex];
    },
    choices: function() {
      return this.selection.options;
    }
  },
  watch: {
    choices: function() {
      return this.displayValue = '';
    }
  },
  methods: {
    choiceClicked: function(choice) {
      this.displayValue = choice.name;
      this.$refs.selection_popover.close();
      return this.$emit('choiceClicked', choice, this.selectionIndex);
    }
  }
};

export default CascadedSelect = {
  props: ['resource', 'defaultValue'],
  components: {
    'selection': Selection
  },
  data: function() {
    return {
      selections: [],
      hierarchy: new Skylark.Libs.Hierarchy(),
      selected_ids: []
    };
  },
  template: `<div class="cascaded-select">
  <div class="selection" v-for='(selection, index) in selections'>
    <selection :selection='selection'
               :selectionIndex='index'
               :selected_ids='selected_ids'
               @choiceClicked='choiceClicked'></selection>
  </div>
</div>`,
  created: function() {
    if (this.defaultValue) {
      return this._fetch(Skylark.Helpers.UrlHelper.generateUrlWithParams(`${this.resource}/${this.defaultValue}`, {
        include_siblings: true,
        include_ancestors: true,
        include_roots: true
      }), {
        success: (data, xhr) => {
          var choice;
          choice = new Skylark.Libs.HierarchicalTreeNode(data.data);
          this.selected_ids = choice.path_ids;
          return this._getRootChoice();
        }
      });
    } else {
      return this._getRootChoice();
    }
  },
  methods: {
    _getRootChoice: function() {
      return this._fetch(Skylark.Helpers.UrlHelper.extendJSON(this.resource), {
        success: (data, xhr) => {
          var _rootNodes;
          this.hierarchy.addNodes(data.data || []);
          _rootNodes = this.hierarchy.getRootNodes();
          this.selections.push({
            options: _rootNodes
          });
          this.selections[0].selectedOption = _.find(_rootNodes, (node) => {
            return node.id === _.first(this.selected_ids);
          });
          if (this.selected_ids.length > 1) {
            return this._setChoices(this.selected_ids);
          }
        }
      });
    },
    _setChoices: function(path_ids, current_path_id) {
      var ancestory_ids;
      if (!current_path_id) {
        current_path_id = _.first(path_ids);
      }
      ancestory_ids = _.rest(path_ids);
      return this._fetch(Skylark.Helpers.UrlHelper.extendJSON(`${this.resource}/${current_path_id}/children`), {
        success: (data, xhr) => {
          var _currentPathOptions, _selectedChoice;
          _currentPathOptions = this.hierarchy.addNodes(data || []);
          _selectedChoice = _.find(_currentPathOptions, function(option) {
            return option.id === _.first(ancestory_ids);
          });
          this.selections.push({
            selectedOption: _selectedChoice,
            options: _currentPathOptions
          });
          if (_selectedChoice != null ? _selectedChoice.children_count : void 0) {
            return this._setChoices(ancestory_ids, _selectedChoice.id);
          }
        }
      });
    },
    choiceClicked: function(choice, selectionIndex) {
      if (choice.id === this.selected_ids[selectionIndex]) {
        return;
      }
      this.selections.splice(selectionIndex + 1, this.selections.length - selectionIndex - 1);
      this.selected_ids.splice(selectionIndex, this.selected_ids.length - selectionIndex);
      this.selections[selectionIndex].selectedOption = choice;
      if (choice.children_count) {
        this._fetch(Skylark.Helpers.UrlHelper.extendJSON(`${this.resource}/${choice.id}/children`), {
          success: (data, xhr) => {
            this.hierarchy.addNodes(data || []);
            return this.selections.push({
              options: choice.children
            });
          }
        });
      }
      this.selected_ids.push(choice.id);
      return this.$emit('valueChange', choice);
    },
    _fetch: function(url, {success, error}) {
      return Skylark.Libs.Ajax.get(url, {
        success: function(data, xhr) {
          return typeof success === "function" ? success(data, xhr) : void 0;
        },
        error: function(xhr, status) {
          console.log('加载失败!');
          return typeof error === "function" ? error(xhr) : void 0;
        }
      });
    }
  }
};
